import { useLingui } from '@lingui/react/macro'
import Link from 'next/link'

export const FindUs = () => {
	const { t } = useLingui()

	return (
		<ul className='flex flex-col'>
			<li className='mb-1 font-bold'>{t`Retrouvez nous`}</li>

			<li>
				<Link
					href='https://www.instagram.com/cocoonspace/?hl=fr'
					target='_blank'
					className='hover:text-primary text-sm'
				>
					Instagram
				</Link>
			</li>

			<li>
				<Link
					href='https://fr.linkedin.com/company/cocoon-space'
					target='_blank'
					className='hover:text-primary text-sm'
				>
					LinkedIn
				</Link>
			</li>
		</ul>
	)
}
